<container-element [ngSwitch]="section?.sectionStyle">
  <dash-gallery class="content-section" *ngSwitchCase="'image_round'" [section]="section"></dash-gallery>
  <dash-stacked class="content-section" *ngSwitchCase="'stacked'" [section]="section"></dash-stacked>
  <dash-round class="content-section" *ngSwitchCase="'round'" [section]="section"></dash-round>
  <dash-wrap class="content-section" *ngSwitchCase="'wrap'" [section]="section"></dash-wrap>
  <div *ngSwitchDefault>GALLERY TYPE TODO!</div>
</container-element>
